module.exports = __webpack_public_path__ + "static/media/pluja.4870138a.svg";


//////////////////
// WEBPACK FOOTER
// ./src/images/avis/pluja.svg
// module id = 819
// module chunks = 0